"use client";

import "./landing.css";
import { MotionConfig } from "framer-motion";
import Footer from "@/components/Footer";
import { Clubs, Contact, Steps } from "./Bottom";
import { Director } from "./Director";
import { archivo, geist } from "./fonts";
import { Passport } from "./Passport";
import { CameraTeardown } from "./CameraTeardown";
import { Coaches, Players } from "./Sections";
import { Facts, Hero, Nav } from "./Top";
import { useLandingLang } from "./useLang";

/** The landing page in the app's Stadium Night language. */
export default function Landing() {
  const [lang, onLang] = useLandingLang();

  return (
    <MotionConfig reducedMotion="user">
      <div className={`sn ${archivo.variable} ${geist.variable} min-h-screen`}>
        <Nav lang={lang} onLang={onLang} />
        <main>
          <Hero lang={lang} />
          <Facts lang={lang} />
          <CameraTeardown lang={lang} />
          <Director lang={lang} />
          <Coaches lang={lang} />
          <Players lang={lang} />
          <Passport lang={lang} />
          <Clubs lang={lang} />
          <Steps lang={lang} />
          <Contact lang={lang} />
        </main>
        <Footer lang={lang} />
      </div>
    </MotionConfig>
  );
}
